// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl:"http://asago.bixbytessolutions.com/api/v1/",
  // imgUrl:"http://asago.bixbytessolutions.com/storage"
  // apiUrl:"http://localhost:8001/api/v1/",
  // imgUrl:"http://localhost:8001/storage",
  // apiUrl:"https://test1.bixbytessolutions.com/api/v1/",
  // imgUrl:"https://test1.bixbytessolutions.com/storage"
   //old url
  // apiUrl:"https://asago-api-test.bixbytessolutions.com/api/v1/",
  // imgUrl:"https://asago-api-test.bixbytessolutions.com/storage"
  // apiUrl:"https://asago-api-uat.bixbytessolutions.com/api/v1/",
  // imgUrl:"https://asago-api-uat.bixbytessolutions.com/storage"
  //deepak gave new url
  
  apiUrl:"https://llmify-api.bixbytessolutions.com/api/v1/",
  imgUrl:"https://llmify-api.bixbytessolutions.com/storage"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
